
  export default {
    data() {
      return {
        activeTab: 'local',
        fileList: {
          total: 0,
          totalPage: 1,
          nowPage: 1,
          pageSize: 10,
          rows: []
        },
        fileSelected: { id: '' },
        fileListLoading: false,
        remoteFileUrl: '',
        
      }
    },
    mounted() {
      
    },
    computed: {
      currentFileUrl() {
        switch(this.activeTab) {
          case 'local':
            return this.fileSelected?.url;
          case 'remote':
            return this.remoteFileUrl;
          default:
            return ''
        }
      },
      confirmDisabled() {
        switch(this.activeTab) {
          case 'local':
            return !this.fileSelected;
          case 'remote':
            return !this.remoteFileUrl;
          default:
            return true;
        }
      }
    },
    methods: {
      async fetchFileList() {
        this.fileListLoading = true;
        this.fileList = await this.$axios.$get(`/resources/getResourcesList.do?sid=483&nowPage=${this.fileList.nowPage}&pageSize=${this.fileList.pageSize}`);
        this.fileListLoading = false;
      },
      getCurrentRow(row) {
        this.fileSelected = row;
      },
      handleFileChange() {
        this.fileList.nowPage = 1;
        this.fetchFileList();
      },
      handleFileListChange() {
        this.fetchFileList();
      },
      handleCurrentRowChange(row) {
        this.fileSelected = row;
      },
      handleConfirm() {
        this.$store.commit('editor/hideFilePickerDialog');
        this.$store.state.editor.filePickerDialog.onConfirm(this.currentFileUrl);
        this.fileSelected = { id: {} };
      },
      handleOpen() {
        // 打开时初始化组件状态
        this.$store.commit('editor/disableHover');
        this.fetchFileList();
        this.activeTab = 'local';
        this.remoteFileUrl = this.$store.state.editor.filePickerDialog.url;
      },
      handleClose() {
        this.$store.commit('editor/enableHover');
      }
    }
  }
